import {BBModel} from "../../bb_model";
import {BaseModel} from "../base";

class CollectionModel extends BaseModel {

    getNextPage(params) {

        return new Promise((resolve, reject) => {

            this.$get('next', params).then(collection => resolve(new BBModel.BBCollection(collection))
                , () => reject());

        });
    }
}

export {
    CollectionModel
}